import React from 'react';
import { DatePicker, Button, Typography } from 'antd';
import dayjs from 'dayjs';

const { Text } = Typography;
const { RangePicker } = DatePicker;

export interface CycleDetailDateFilterBarProps {
  dateRange: [any, any];
  onDateRangeChange: (dates: [any, any]) => void;
  onQuickFilter: (months: number | 'all' | 'week') => void;
  onYearFilter: () => void;
  isMobile?: boolean;
}

export const CycleDetailDateFilterBar: React.FC<CycleDetailDateFilterBarProps> = ({
  dateRange,
  onDateRangeChange,
  onQuickFilter,
  onYearFilter,
  isMobile = false,
}) => {
  return (
    <div
      style={{
        marginBottom: '16px',
        borderBottom: '1px solid #f0f0f0',
        paddingBottom: '12px',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: isMobile ? 'flex-start' : 'center',
            gap: '8px',
            width: '100%',
          }}
        >
          <Text
            strong
            style={{ fontSize: isMobile ? 12 : 14, whiteSpace: 'nowrap' }}
          >
            Filtrar por Fecha:
          </Text>
          <RangePicker
            value={dateRange}
            onChange={(dates) => onDateRangeChange(dates as any)}
            format="DD/MM/YYYY"
            placeholder={['Fecha Inicial', 'Fecha Final']}
            style={{ width: isMobile ? '100%' : 'auto', maxWidth: '100%' }}
            size={isMobile ? 'small' : 'middle'}
          />
        </div>
        <div
          className="mobile-scroll-x"
          style={{
            display: 'flex',
            gap: 6,
            flexWrap: isMobile ? 'nowrap' : 'wrap',
            paddingBottom: 4,
            width: '100%',
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          <Button
            size="small"
            type={
              dateRange[0]?.isSame(dayjs().subtract(7, 'day'), 'day') &&
              dateRange[1]?.isSame(dayjs(), 'day')
                ? 'primary'
                : 'default'
            }
            onClick={() => onQuickFilter('week')}
          >
            7 días
          </Button>
          <Button
            size="small"
            type={
              dateRange[0]?.isSame(dayjs().subtract(1, 'month'), 'day') &&
              dateRange[1]?.isSame(dayjs(), 'day')
                ? 'primary'
                : 'default'
            }
            onClick={() => onQuickFilter(1)}
          >
            1 Mes
          </Button>
          <Button
            size="small"
            type={
              dateRange[0]?.isSame(dayjs().subtract(3, 'month'), 'day') &&
              dateRange[1]?.isSame(dayjs(), 'day')
                ? 'primary'
                : 'default'
            }
            onClick={() => onQuickFilter(3)}
          >
            3 Meses
          </Button>
          <Button
            size="small"
            type={
              dateRange[0]?.isSame(dayjs().startOf('year'), 'day')
                ? 'primary'
                : 'default'
            }
            onClick={onYearFilter}
          >
            Este Año
          </Button>
          <Button
            size="small"
            type={dateRange[0] ? 'default' : 'primary'}
            onClick={() => onQuickFilter('all')}
          >
            Todo
          </Button>
        </div>
      </div>
    </div>
  );
};
